const SubAbas = [
  { label: 'Básico', rota: '/secsaude/programacao/basico' },
  {
    label: 'Especializado',
    rota: '/secsaude/programacao/especializado',
  },
  { label: 'Estratégico', rota: '/secsaude/programacao/estrategico' },
  { label: 'Entregas', rota: '/secsaude/programacao/entregas' },
];

export default SubAbas;
